import axios from '/src/common/axios'

export function getNsi(dictName, request) {
  return axios.get('/api/nsi/' + dictName, { params: request })
}

export default {
  loadSelectOptions(dictName, optionsArray, requestData, isClear) {
    getNsi(dictName, requestData).then(function (response) {
      if (isClear) {
        while (optionsArray.length > 1) optionsArray.pop();
      }

      if (response.data && response.data.length) {
        response.data.forEach((i) => optionsArray.push(i));
      }
    });
  },
  downloadFileByUid(uid, filename) {
    return this.downloadFile(`/api/file/downloadByGuid?guid=${uid}`, filename);
  },
  downloadFile(url, filename) {
    return axios.get(url, { responseType: 'blob' })
      .then(response => {
        const blob = new Blob([response.data], { type: response.data.type });
        const link = document.createElement('a');
        const contentDisposition = response.headers['content-disposition'];
        // if (contentDisposition) {
        //   const matches = contentDisposition.match(/filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?/);
        //   if (matches.length === 2) {
        //     filename = matches[1];
        //   }
        // }

        if (contentDisposition) {
          // Пытаемся взять filename*=
          let utfFilename = contentDisposition.match(/filename\*=([^;]+)/);
          if (utfFilename && utfFilename[1]) {
            const value = utfFilename[1].trim();
            // формат RFC 5987: UTF-8''%D0...
            const parts = value.split("''");
            if (parts.length === 2) {
              filename = decodeURIComponent(parts[1]);
            }
          } else {
            // Иначе обычный filename=""
            let asciiFilename = contentDisposition.match(/filename="(.+?)"/);
            if (asciiFilename && asciiFilename[1]) {
              filename = asciiFilename[1];
            }
          }
        }

        link.href = URL.createObjectURL(blob);
        link.download = filename || 'download';
        link.click();
        URL.revokeObjectURL(link.href);
      });
  }
}